import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
function getExternalActions() {
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.ContentUI.externalValueActions().url));
}
export default function useExternalActionsQuery({
  isLoadingSecurityLicense,
  isValidSecurityLicense
}) {
  const { isFetching, isError, data, error } = useQuery({
    queryKey: ["externalActions"],
    queryFn: () => defaultOnError(
      getExternalActions(),
      i18n.t("notifications.fetch_external_actions_failed", { ns: "enterprise_security" })
    ),
    enabled: !isLoadingSecurityLicense && isValidSecurityLicense
  });
  return {
    isFetching,
    isError,
    data,
    error
  };
}
